module.exports = __webpack_public_path__ + "static/media/logo.a7e5b579.svg";